import React from 'react';
import { Route, Switch } from 'react-router-dom';

import NetworkForm from 'routes/app/components/Broadcast/NetworkForm';

class Twitter extends React.Component {

  render() {
    return (
      <Switch>
        <Route path={this.props.match.path} render={() => <NetworkForm type="twitter"/>}/>
      </Switch>
    )
  }
}

module.exports = Twitter;



// WEBPACK FOOTER //
// ./routes/app/routes/broadcast/twitter/index.js